import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ClearingAccountChart from "../Clearing Account Report Chart/ClearingAccountChart";
import { ClearingAccountReportLoadingDialog } from "./clearing-account-report-loading-dialog/ClearingAccountReportLoadingDialog";
import * as actions from "./clearing-account-report-redux/clearingAccountReportActions";
import { ClearingAccountReportCard } from "./ClearingAccountReportCard";
import { ClearingAccountReportUIProvider } from "./ClearingAccountReportUIContext";
import {
  initialFilter,
  initialFilterChart
} from "./ClearingAccountReportUIHelpers";

export function ClearingAccountReportPage({ history }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [queryParamsChart, setqueryParamsChartBase] = useState(
    initialFilterChart
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.fetchClearingAccountReportList(queryParams));
  }, [queryParams, dispatch]);

  useEffect(() => {
    dispatch(actions.fetchClearingAccountChartDetails(queryParamsChart));
  }, [queryParamsChart, dispatch]);

  const clearingAccountReportUIEvents = {
    openReceiptDialog: (row) => {},
    handleExportButton: () => {
      dispatch(actions.exportClearingAccountReportList(queryParams));
    }
  };

  return (
    <>
      <ClearingAccountReportUIProvider
        clearingAccountReportUIEvents={clearingAccountReportUIEvents}
        queryParams={queryParams}
        setQueryParamsBase={setQueryParamsBase}
        queryParamsChart={queryParamsChart}
        setqueryParamsChartBase={setqueryParamsChartBase}
      >
        <ClearingAccountReportLoadingDialog />

        <ClearingAccountChart />

        <ClearingAccountReportCard />
      </ClearingAccountReportUIProvider>
    </>
  );
}
